export const COLOR = Styles.color.accent;
